export { default as OutfitSizePicker } from './outfitSizePicker'


// WEBPACK FOOTER //
// ./src/modules/outfits/outfitSizePicker/index.js